// extracted by mini-css-extract-plugin
module.exports = {"home":"home-2MD1B"};